namespace $ {

	const $shm_hitalama_app_offline_blacklist = new Set([
		'//cse.google.com/adsense/search/async-ads.js',
	])

	let $shm_hitalama_app_offline_register_native: ServiceWorkerContainer[ 'register' ] | null = null

	function $shm_hitalama_app_offline_registration_stub() {
		return {
			installing: null,
			waiting: null,
			active: null,
			addEventListener() {},
			removeEventListener() {},
			unregister: ()=> Promise.resolve( true ),
			update: ()=> Promise.resolve( null ),
		} as unknown as ServiceWorkerRegistration
	}

	function $shm_hitalama_app_offline_disable_register() {
		const service_worker = navigator.serviceWorker
		if( !service_worker ) return
		if( $shm_hitalama_app_offline_register_native ) return

		$shm_hitalama_app_offline_register_native = service_worker.register.bind( service_worker )
		service_worker.register = ( ( script_url: string | URL, options?: RegistrationOptions )=> {
			if( location.hostname.startsWith( 'hitalama.' ) ) {
				return Promise.resolve( $shm_hitalama_app_offline_registration_stub() )
			}

			return $shm_hitalama_app_offline_register_native!( script_url, options )
		} ) as ServiceWorkerContainer[ 'register' ]
	}

	function $shm_hitalama_app_offline_enrich( response: Response ) {
		if( !response.status ) return response

		const headers = new Headers( response.headers )
		headers.set( '$mol_offline', '' )
		headers.set( 'Origin-Agent-Cluster', '?1' )

		return new Response( response.body, {
			status: response.status,
			statusText: response.statusText,
			headers,
		} )
	}

	function $shm_hitalama_app_offline_fetch( event: any, request: Request ) {
		return fetch( request ).then( response => {
			if( response.status !== 200 ) return response

			event.waitUntil(
				caches.open( '$mol_offline' ).then(
					cache => cache.put( request, response ),
				),
			)

			return response.clone()
		} )
	}

	function $shm_hitalama_app_offline_response( event: any, request: Request ) {
		const fresh = request.cache === 'force-cache'
			? null
			: $shm_hitalama_app_offline_fetch( event, request )

		if( fresh ) event.waitUntil( fresh.then( $shm_hitalama_app_offline_enrich ) )

		return caches.match( request ).then(
			cached => request.cache === 'no-cache' || request.cache === 'reload'
				? ( cached
					? fresh!
						.then( actual => {
							if( actual.status === cached.status ) return actual
							throw new Error(
								`${ actual.status }${ actual.statusText ? ` ${ actual.statusText }` : '' }`,
								{ cause: actual },
							)
						} )
						.catch( ( error: Error )=> {
							const cloned = cached.clone()
							const message = `${ error.cause instanceof Response ? '' : '500 ' }${ error.message } $mol_offline fallback to cache`
							cloned.headers.set( '$mol_offline_remote_status', message )
							return cloned
						} )
					: fresh!
				)
				: ( cached || fresh || $shm_hitalama_app_offline_fetch( event, request ) ),
		).then( $shm_hitalama_app_offline_enrich )
	}

	export function $shm_hitalama_app_offline() {

		if( typeof window === 'undefined' ) {

			self.addEventListener( 'install', ( event: any )=> {
				;( self as any ).skipWaiting()
			} )

			self.addEventListener( 'activate', ( event: any )=> {
				;( self as any ).clients.claim()

				$$.$mol_log3_done({
					place: '$shm_hitalama_app_offline',
					message: 'Activated',
				})
			} )

			self.addEventListener( 'fetch', ( event: any )=> {
				const request = event.request

				if( $shm_hitalama_app_offline_blacklist.has( request.url.replace( /^https?:/, '' ) ) ) {
					return event.respondWith( new Response( null, { status: 418, statusText: 'Blocked' } ) )
				}

				if( request.method !== 'GET' ) return
				if( !/^https?:/.test( request.url ) ) return
				if( /\?/.test( request.url ) ) return
				if( request.cache === 'no-store' ) return

				event.respondWith( $shm_hitalama_app_offline_response( event, request ) )
			} )

			self.addEventListener( 'beforeinstallprompt', ( event: any )=> event.prompt() )

		} else if( location.hostname.startsWith( 'hitalama.' ) ) {
			$shm_hitalama_app_offline_disable_register()
			$mol_dom.addEventListener( 'DOMContentLoaded', ()=> {
				navigator.serviceWorker?.getRegistrations?.().then( async registrations => {
					await Promise.all( registrations.map( registration => registration.unregister() ) )
					await caches?.delete?.( '$mol_offline' )
				} ).catch( error => console.warn( error ) )
			} )
		} else if( location.protocol !== 'https:' && location.hostname !== 'localhost' ) {
			console.warn( 'HTTPS or localhost is required for service workers.' )
		} else if( !navigator.serviceWorker ) {
			console.warn( 'Service Worker is not supported.' )
		} else {
			$mol_dom.addEventListener( 'DOMContentLoaded', ()=> {
				navigator.serviceWorker.register( 'web.js' ).then( reg => {
					reg.addEventListener( 'updatefound', ()=> {
						$$.$mol_log3_rise({
							place: '$shm_hitalama_app_offline',
							message: 'Outdated',
						})

						const worker = reg.installing!
						worker.addEventListener( 'statechange', ()=> {
							if( worker.state !== 'activated' ) return
							window.location.reload()
						} )
					} )
				} ).catch( error => console.warn( error ) )
			} )
		}
	}

	$.$mol_offline = $shm_hitalama_app_offline
	$.$mol_offline_web = $shm_hitalama_app_offline

	try {
		$.$mol_offline()
	} catch( error ) {
		console.error( error )
	}

}
